/* Packages */
import React from 'react';
import { render } from 'react-dom';

const relatedProductsNodes = Array.from(document.querySelectorAll('[data-related-products]'));
if (relatedProductsNodes.length) {
    import(/* webpackChunkName: "RelatedProducts" */ './components/RelatedProducts').then(({ default: RelatedProducts }) => {
        relatedProductsNodes.forEach((node) => render(<RelatedProducts {...(JSON.parse(node.dataset.relatedProducts || '{}'))}/>, node));
    });
}
